import { useMemo } from 'react';

import type { ColDef } from '@/grid/types';
import {
  dateOnlyFormatter,
  dateOnlyParser,
} from '@/grid/value-formatters/dateOnlyFormatter';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

import { ROW_NUMBER_COLUMN } from '../../utils/row-number-column';
import type { FarbroBulkDonorScheduleInput } from '../utils/schema';

export function useFarbroColumns() {
  const fixBulkDonorScheduleDateFormat = useFeatureFlag(
    'fix_bulk_donor_schedule_date_format',
  );

  return useMemo<ColDef<FarbroBulkDonorScheduleInput>[]>(
    () => [
      ROW_NUMBER_COLUMN,
      {
        headerName: 'Donor ID',
        field: 'donorNameToMatch',
        initialWidth: 85,
      },
      {
        headerName: 'Donor Registration',
        field: 'donorRegistrationNumber',
        initialWidth: 140,
      },
      {
        headerName: 'Birth Date',
        field: 'birthDate',
        initialWidth: 100,
        valueFormatter: fixBulkDonorScheduleDateFormat
          ? dateOnlyFormatter
          : undefined,
        valueParser: fixBulkDonorScheduleDateFormat
          ? dateOnlyParser
          : undefined,
        cellEditorParams: fixBulkDonorScheduleDateFormat
          ? { useFormatter: true }
          : undefined,
      },
      {
        headerName: 'Donor Breed',
        field: 'donorBreed',
        initialWidth: 100,
      },
      {
        headerName: 'Where',
        field: 'location',
        initialWidth: 70,
      },
      {
        headerName: 'OPU Date',
        field: 'opuDate',
        initialWidth: 90,
        valueFormatter: fixBulkDonorScheduleDateFormat
          ? dateOnlyFormatter
          : undefined,
        valueParser: fixBulkDonorScheduleDateFormat
          ? dateOnlyParser
          : undefined,
        cellEditorParams: fixBulkDonorScheduleDateFormat
          ? { useFormatter: true }
          : undefined,
      },
      {
        headerName: 'Sire ID',
        field: 'naab',
        initialWidth: 110,
      },
      {
        headerName: 'Sire Name',
        field: 'sire',
        initialWidth: 130,
      },
      {
        headerName: 'Semen Type',
        field: 'semenType',
        initialWidth: 100,
      },
      {
        headerName: 'Collection Code',
        field: 'collectionCode',
        initialWidth: 120,
      },
      {
        headerName: 'Priority',
        field: 'priority',
        initialWidth: 90,
      },
    ],
    [fixBulkDonorScheduleDateFormat],
  );
}
